
<script>
import WebRTCService from './services/WebRTCService'
import { fabric } from 'fabric'
import './filters/removegreen'
export default {
  name: 'SgVhumanVue2',
  props: {
    width: { type: Number, default: () => 400 },
    height: { type: Number, default: () => 400 },
    iceUrl: { type: String, default: () => '' },
    offerUrl: { type: String, default: () => '' },
    humanUrl: { type: String, default: () => '' },
    backgroundColor: { type: String, default: () => '#FFFFFF' }
  },
  data() {
    return {
      isConnected: false,
      webRTC: null,
      digitalHumanVideo: null,
      sessionId: 0,
      videoCanvas: null
    }
  },

  methods: {
    /*
 *@description:初始化数字人
 *@author: miaochan
 *@date: 2025-07-03 15:33:31
*/
    async init() {
      this.webRTC = new WebRTCService()
      await this.webRTC.initializeConnection({
        sdpSemantics: 'unified-plan'
      })

      this.webRTC.onRemoteStreamReceived = (stream) => {
        if (this.$refs.digitalHumanVideo) {
          this.$refs.digitalHumanVideo.srcObject = stream
        }
      }

      this.webRTC.onIceCandidate = async(candidate) => {
        if (!this.sessionId) return
        try {
          const response = await fetch(this.iceUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              candidate: candidate,
              sessionid: this.sessionId
            })
          })
          if (!response.ok) {
            console.log('Failed to send ICE candidate')
            this.$emit('on-connect-failed', new Error('Failed to send ICE candidate'))
          }
        } catch (error) {
          this.$emit('on-connect-failed', error)
          console.log('Error sending ICE candidate:')
        }
      }
    },
    /*
 *@description:连接数字人
 *@author: miaochan
 *@date: 2025-07-03 15:34:52
 *@param:
 *@param:
*/
    async connect() {
      try {
        this.init()
        const offer = await this.webRTC.createOffer()
        console.log('Creating offer:', offer)

        const response = await fetch(this.offerUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            sdp: offer.sdp,
            type: offer.type
          })
        })

        if (!response.ok) {
          // connectToDigitalHuman()
        }

        const data = await response.json()

        if (!data || !data.sdp) {
          this.$emit('on-connect-failed', new Error('Invalid response from server'))
        }

        const answerDescription = {
          type: 'answer',
          sdp: data.sdp
        }

        this.sessionId = data.sessionid
        await this.webRTC.handleAnswer(answerDescription)
        this.isConnected = true
        this.$emit('on-connect-success')
      } catch (error) {
        this.isConnected = false
        this.$emit('on-connect-failed', error)
      }
    },

    /**
   * @description:断开数字人
   * @author: miaochan
   * @date: 2025-04-16 15:47:39
   * @param:
   * @return:
   */
    // eslint-disable-next-line no-unused-vars
    disconnect() {
      try {
        if (this.webRTC) {
          this.webRTC.closeConnection()
          if (this.$refs.digitalHumanVideo) {
            this.$refs.digitalHumanVideo.srcObject = null
          }
          this.$emit('on-disconnect-success')
        }
      } catch (error) {
        this.$emit('on-disconnect-failed', error)
      } finally {
        this.isConnected = false
        this.sessionId = 0
        this.webRTC = null
      }
    },
    /*
    *@description:去掉绿布
    *@author: miaochan
    *@date: 2025-07-03 15:39:37
    *@param:
    *@param:
    */
    async computeFrame() {
      const canvas = new fabric.Canvas('canvas', { backgroundColor: this.backgroundColor })
      canvas.skipTargetFind = true
      if (this.$refs.digitalHumanVideo) {
        if (this.$refs.digitalHumanVideo.paused || this.$refs.digitalHumanVideo.ended) return
      }
      const video = new fabric.Image(this.$refs.digitalHumanVideo, { selectable: false })

      video.filters.push(
        new fabric.Image.filters.RemoveGreen({
          similarity: 0.44,
          smoothness: 0.06,
          spill: 0.02
        })
      )

      video.applyFilters()

      // 也可以使用setElement()方法，将已经加载好的视频元素传入

      canvas.add(video)

      fabric.util.requestAnimFrame(function render() {
        fabric.filterBackend.evictCachesForKey(video.cacheKey)
        // 应用滤镜
        video.applyFilters()
        // console.log('renderAll')
        canvas.renderAll()
        fabric.util.requestAnimFrame(render)
      })
      // 视频正常加载后，再生成 fabric.Image 对象
    },
    /*
    *@description:发送消息回调函数
    *@author: miaochan
    *@date: 2025-07-03 17:14:37
    *@param:
    *@param:
    */
    async sendMessage(value) {
      if (!this.isConnected) {
        this.$emit('on-send-failed')
      } else {
        try {
          const response = await fetch(this.humanUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              text: value,
              type: 'echo',
              interrupt: true,
              sessionid: this.sessionId
            })
          })

          if (response.ok) {
            console.log('Message sent successfully')
          } else {
            this.$emit('on-send-failed', new Error('Failed to send message'))
          }
        } catch (error) {
          this.$emit('on-send-failed', error)
        }
      }
    }
  }

}
</script>
<template>
  <div
    v-show="isConnected"
    :style="{ width:width+'px',height:height+'px'}"
    class="video-box"
  >
    <video
      ref="digitalHumanVideo"
      autoplay
      style="opactiy: 0"
      :width="width"
      :height="height"
      @canplay="computeFrame"
    />

    <div v-if="isConnected" class="bg-content">
      <canvas

        id="canvas"
        ref="videoCanvas"
        :width="width"
        :height="height"
      />
    </div>
    <!--  -->
  </div>
</template>
<style scoped lang="scss">
  .video-box {
    width: fit-content;
    border-radius: 12px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;

    video {
      width: 100%;
      opacity: 0;
      // height: 100%;
      // object-fit: cover;
    }
    .bg-content {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

</style>
